window.VH = window.VH === undefined ? {} : window.VH;
VH.Sidebar = {
    sidebar : false,

    toggle : function toggle(e) {
        let _t = VH.Sidebar;
        VH.Helper.b.toggleClass("sidebar-toggled");
        _t.sidebar.toggleClass("toggled");
        if (_t.sidebar.hasClass("toggled")) {
            $('.collapse', _t.sidebar).collapse('hide');
        }
    },

    resize : function() {
        let _t = VH.Sidebar,
            width = VH.Helper.w.width();
        if (width < 768 && !_t.sidebar.hasClass("toggled")) {
            _t.toggle();
        }
    },

    init : function init() {
        let _t = VH.Sidebar;
        _t.sidebar = $(".sidebar");

        $("#sidebarToggle, #sidebarToggleTop").on('click', _t.toggle);

        VH.Helper.w.resize(_t.resize);
        _t.resize();
    }
};
